
import React from 'react';
import PropTypes from 'prop-types';
import MuiSwitch from "../../../../components/MuiComponents/MuiSwitch";

const SwitchStatus = props => {

    const { checked, disabled, onChange } = props;

    
    return (
        <MuiSwitch 
            checked={checked}
            disabled={disabled}
            onChange={onChange}            
        />
    )
}

SwitchStatus.propTypes = {    
    checked: PropTypes.bool,
    disabled: PropTypes.bool,
};

export default SwitchStatus;